module.exports = __webpack_public_path__ + "static/media/Cersei Lannister.405bf445.jpg";